export function init_sales_detail_valid() {
  $(document).on('change input', '.js-sales-detail-form #date_from, .js-sales-detail-form #date_to', function() {
    const $form = $(this).closest('form');
    const $submitBtn = $form.find('.js-sales-detail-submit');

    const dateFromStr = $form.find('#date_from').val();
    const dateToStr = $form.find('#date_to').val();

    const dateFrom = new Date(dateFromStr);
    const dateTo = new Date(dateToStr);

    const oneYearLater = new Date(dateFrom);
    oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);

    let isValid = true;

    //空チェック
    if (!dateFromStr || !dateToStr) {
      isValid = false;
    } 
    //日付の有効性チェック
    else if (isNaN(dateFrom.getTime()) || isNaN(dateTo.getTime())) {
      isValid = false;
    }
    //整合性チェック
    else if (dateFrom > dateTo) {
      isValid = false;
    }
    //1年間チェック(開始日が2/29の場合、3/1まで有効)
    else if (dateTo > oneYearLater) {
      isValid = false;
    }

    if (isValid) {
      $submitBtn.removeClass('is-disabled');
    } else {
      $submitBtn.addClass('is-disabled');
    }
  });
}

export function init_sales_detail_request() {
  var $modalTrigger = null;

  $(document).on('click', '.js-sales-detail-form .js-sales-detail-submit', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var $form = $btn.closest('form');
    var $errorTxt = $form.find('.form-error-txt');
    
    // 処理中なら何もしない
    if ($btn.data('processing')) {
      return;
    }
    
    // エラーメッセージをクリア
    $errorTxt.hide();
    $errorTxt.text('');

    // 確認ダイアログ
    if (!confirm('売上明細表を発行しますか？')) {
      return;
    }
    
    // 処理中フラグを立ててボタンを無効化
    $btn.data('processing', true);
    $btn.addClass('is-disabled');
    
    $.ajax({
      url: $form.attr('action'),
      type: 'POST',
      data: $form.serialize(),
      dataType: 'json',
      success: function(response) {
        if (response.success) {
          // 成功時: エラーメッセージを非表示
          $errorTxt.hide();
          if ($modalTrigger) {
            $modalTrigger.modaal('destroy');
            $modalTrigger.remove();
            $modalTrigger = null;
          }
          // Modaalを初期化してモーダルを開く
          $modalTrigger = $('<a href="#modalSalesDetail"></a>');
          $modalTrigger.modaal({
            overlay_opacity: '0.5',
            custom_class: 'modal-wrap',
            hide_close: false,
            after_open: function() {
              $('.modaal-wrapper .js-modal-close')
                .off('click.salesDetail')
                .on('click.salesDetail', function () {
                  $modalTrigger.modaal('close');
              });
            },
            after_close: function () {
              if ($modalTrigger){
                  $modalTrigger.modaal('destroy');
                  $modalTrigger.remove();
                  $modalTrigger = null;
                }
            }
          });
          $modalTrigger.modaal('open');
        } else {
          // エラーメッセージを表示
          $errorTxt.text(response.error_message);
          $errorTxt.show();
        }
      },
      error: function() {
        $errorTxt.text('日付を修正してください。');
        $errorTxt.show();
      },
      complete: function() {
        // 処理完了後、ボタンを有効化
        $btn.data('processing', false);
        $btn.removeClass('is-disabled');
      }
    });
  });
}

export function init_sales_detail_download() {
  // プルダウン変更時に古いリンクを削除
  $(document).on('change', '#sales_statement_select', function() {
    $('.js-sales-detail-download').children('a').remove();
  });

  $(document).on('click', '.js-sales-detail-download', function() {
    const $downloadButton = $(this);
    const $existingLink = $downloadButton.children('a');

    // 既にURLがセットされていたら再利用
    if ($existingLink.length) {
      $existingLink[0].click();
      return;
    }

    // 処理中なら何もしない
    if ($downloadButton.data('processing')) {
      return;
    }

    const $errorDiv = $('#sales_detail_download-error');
    
    // エラー表示をリセット
    $errorDiv.hide();
    $errorDiv.html('');

    const sales_statement_id = $('#sales_statement_select').val();
    
    // プルダウンで選択されていない場合
    if (!sales_statement_id) {
      $errorDiv.html('日付を入力してください');
      $errorDiv.show();
      return;
    }

    $downloadButton.data('processing', true);
    $downloadButton.addClass('is-disabled');

    const url = '/mypage/purchase_histories/sales_detail_download';

    $.ajax({
      type: 'GET',
      url: url,
      data: {
        sales_statement_id: sales_statement_id,
      },
      dataType: 'json'
    })
      .done(function (data) {
        if (data.error_message) {
          $errorDiv.html(data.error_message);
          $errorDiv.show();
          return;
        }

        const $link = $('<a>').attr({
          href: data.presigned_url,
          target: '_blank'
        });
        $downloadButton.append($link);
        $link[0].click();
      })
      .fail(function () {
        $errorDiv.html('ダウンロードに失敗しました。画面を更新して再度お試しください。');
        $errorDiv.show();
      })
      .always(function () {
        // 処理完了後、ボタンを有効化
        $downloadButton.data('processing', false);
        $downloadButton.removeClass('is-disabled');
      });
  });
}